import React from "react";

import { useTranslation, useUserContext } from "utils";

import { COUNTRY_CODE } from "consts";

import { Button, Drawer, Flex, Icon, Typography, WidgetVideo } from "components";

type MissingDataTaskDrawerProps = {
  visible: boolean;
  onClose: () => void;
  onStart: () => void;
};

const VIMEO_URL = "https://player.vimeo.com/video/1156400829?h=dd6c1e4fd9";

const NON_VIDEO_COUNTRIES = new Set([COUNTRY_CODE.UNITED_KINGDOM, COUNTRY_CODE.CZECHIA, COUNTRY_CODE.SLOVAKIA, COUNTRY_CODE.POLAND]);

export const MissingDataTaskDrawer = ({ visible, onClose, onStart }: MissingDataTaskDrawerProps) => {
  const { t } = useTranslation("allFieldView");
  const { user } = useUserContext();

  const showVideo = user?.farm?.country && !NON_VIDEO_COUNTRIES.has(user.farm.country as COUNTRY_CODE);

  return (
    <Drawer
      title={t("tasksDrawer.title")}
      visible={visible}
      onClose={onClose}
      className="missing-data-task-drawer"
      footer={[
        <Flex gap="1rem" key="footer-buttons">
          <Button type="secondary" onClick={onClose}>
            {t("tasksDrawer.tasks.missingData.drawer.back")}
          </Button>
          <Button type="primary" onClick={onStart}>
            {t("tasksDrawer.tasks.missingData.drawer.start")}
          </Button>
        </Flex>,
      ]}
    >
      <Flex vertical gap="1rem">
        <Typography variant="h1">{t("tasksDrawer.tasks.missingData.drawer.title")}</Typography>
        <Typography variant="paragraph-m" className="margin-0">
          {t("tasksDrawer.tasks.missingData.drawer.description")}
        </Typography>
        {showVideo && (
          <>
            <Flex align="center" gap="0.5rem" className="info-banner">
              <Icon iconName="tabler/bulb" />
              <Typography variant="paragraph-m" className="margin-0">
                {t("tasksDrawer.tasks.missingData.drawer.infoBanner")}
              </Typography>
            </Flex>
            <WidgetVideo vimeoUrlOrId={VIMEO_URL} title={t("tasksDrawer.tasks.missingData.drawer.video.title")} allowedCountries={[COUNTRY_CODE.GERMANY]} />
          </>
        )}
        {/* Benefit list */}
        <Flex vertical gap="0.75rem">
          {["benefit1", "benefit2", "benefit3"].map((key) => (
            <Flex key={key} align="center" gap="0.5rem">
              <Icon iconName="tabler/check" />
              <Typography variant="paragraph-m" className="margin-0">
                {t(`tasksDrawer.tasks.missingData.drawer.benefits.${key}`)}
              </Typography>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Drawer>
  );
};
